export default __webpack_public_path__ + "static/media/KOROLEV_Gria_logo_v2_2_Re02.0bc3b934.png";